import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-users-packages',
    templateUrl: './users-packages.component.html',
    styleUrls: ['./users-packages.component.css'],
    standalone: false
})
export class UsersPackagesComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;
  items: any[] = [];
  token: any;

  new_item = {
    name: null,
    full_price: null,
    paied_amount: null,
    no_sessions: null,
    no_sessions_left: null,
    no_sessions_took: null,
    no_sessions_paid: null,
    active: false
  }

  update_key: any;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private titleService: Title) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Packages Settings');
    this.getPackages();
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, item: any) {
    this.update_key = item.Package_Patient.id;
    this.new_item = item;

    this.new_item.name = item.Package_Patient?.service_name;    
    this.new_item.full_price = item.Package_Patient?.full_price;    
    this.new_item.paied_amount = item.Package_Patient?.paied_amount;    
    this.new_item.no_sessions = item.Package_Patient?.no_sessions;    
    this.new_item.no_sessions_left = item.Package_Patient?.no_sessions_left;    
    this.new_item.no_sessions_paid = item.Package_Patient?.no_sessions_paid;    
    this.new_item.no_sessions_took = item.Package_Patient?.no_sessions_took;    
    this.new_item.active = item.Package_Patient?.active;    

    this.modalService.open(content);
  }

  async getPackages() {
    this.utility.loading = true;
    const sub = this.api.get('package_patients/details', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.list_length = this.items.length;
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  async OnUpdate(key: any) {
    let body = {
      full_price: this.new_item.full_price,
      paied_amount: this.new_item.paied_amount,
      no_sessions: this.new_item.no_sessions,
      no_sessions_left: this.new_item.no_sessions_left,
      no_sessions_took: this.new_item.no_sessions_took,
      no_sessions_paid: this.new_item.no_sessions_paid,
      active: this.new_item.active
    }

    this.api.update("package_patients/update/" + key, body, this.token).subscribe(
      async data => {
        this.getPackages();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async onDelete(key: any) {
    if (confirm("Delete this item?")) {
      this.api.delete('package_patients/' + key, this.token).subscribe(
        async data => {
          this.getPackages();
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }
}
